// Minimal DOM helpers — enough to build screens without a framework (plan §13
// keeps the view layer light).

/** Build an element from an HTML string (returns the single root element). */
export function h(html: string): HTMLElement {
  const tpl = document.createElement("template");
  tpl.innerHTML = html.trim();
  const node = tpl.content.firstElementChild;
  if (!(node instanceof HTMLElement)) {
    throw new Error("h(): template did not yield an element");
  }
  return node;
}

/** Escape untrusted text for interpolation into HTML. */
export function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => {
    switch (c) {
      case "&":
        return "&amp;";
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case '"':
        return "&quot;";
      default:
        return "&#39;";
    }
  });
}

/** Show a message in a `.msg` slot, toggling the ok/bad style. */
export function setMsg(el: HTMLElement, text: string, kind: "ok" | "bad" | "" = ""): void {
  el.textContent = text;
  el.className = "msg" + (kind ? ` ${kind}` : "");
}

/** Flatten any thrown value to a plain, single-string form — a full stack for an
 *  Error, else a readable representation — so it logs as *text* in the console
 *  (Chromium renders a logged Error object as an interactive block, not text). */
export function errText(e: unknown): string {
  if (e instanceof Error) return e.stack ?? `${e.name}: ${e.message}`;
  if (typeof e === "string") return e;
  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
}
